export default {
    TIMELINE: "Появление геометок",
    PRESENTATION: "Развитие графа",
    TASKS_LOGS: "Запущенные методы"
};
